// removed by extract-text-webpack-plugin
module.exports = {"toolbar":"toolbar___3CVzN","left":"left___3x91A","right":"right___1DdMD"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/FooterToolbar/index.less
// module id = 439
// module chunks = 0